import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'pt', // Remover esse parametro em produção
    fallbackLng: 'pt',
    debug: false,
    resources: {},
    detection: {
      order: ['localstorage', 'navigator', 'htmlTag'],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
